import React from 'react'
import { graphql } from 'gatsby'
import {
  Layout,
  Wrapper,
  BannerContainer,
  Billboard,
  Button,
  Row,
  Column,
  BannerWrapper,
  Section,
  Title,
  DarkSection,
  SEO,
} from '../components'
import * as Icons from '../components/icons'

import {
  UnderLine,
  SolutionCard,
  OddsCard,
  Background,
  OddsIconWrap,
  PartnerCard,
} from '../molecules/index/atoms'
import AMDLogo from '../images/index/amd.png'
import IntelLogo from '../images/index/intel.png'
import NvidiaLogo from '../images/index/nvidia.png'
import ARMLogo from '../images/index/arm.png'
import BG from '../images/index/bg.png'

function Index(props) {
  const { data } = props
  return (
    <Layout>
      <SEO
        title='云游戏服务器，云游戏解决方案商-斗龙云游戏'
        keywords='云游戏服务器,云游戏服务商,云游戏解决方案商,游戏云化,云试玩,斗龙云'
        description='斗龙云游戏解决方案，为游戏内容厂商、渠道厂商提供智能底层IaaS服务，一站式PaaS服务，打造优质云游戏体验，云试玩助力游戏云化，云游戏Iaas解决方案和云游戏Pass解决方案，一站式云游戏行业整体解决方案商。'
      />
      <BannerContainer height={900} mobileHeight={450}>
        <BannerWrapper>
          <h1>
            斗龙云游戏
            <br />
            解决方案
          </h1>
          <UnderLine />
          <p>为游戏内容厂商、渠道厂商，提供智能底层IaaS服务， 一站式PaaS服务，打造优质云游戏体验</p>
          <Button
            width={180}
            size='gigant'
            onClick={() => window.scrollTo(0, document.documentElement.offsetHeight)}
          >
            立即咨询
          </Button>
        </BannerWrapper>
        <Billboard fluid={data.banner.childImageSharp.fluid} />
      </BannerContainer>
      <Section>
        <Wrapper>
          <Row>
            <Column xs='12' lg='6'>
              <SolutionCard>
                <Icons.Index1 />
                <h3>云游戏Paas解决方案</h3>
                <p>
                  为游戏内容厂商提供多端SDK，高效接入，快速完成云游戏移植，部署云游戏服务。用户仅需下载轻量化的APP或客户端，即可畅玩大型游戏，降低用户的时间和设备升级成本。
                </p>
              </SolutionCard>
            </Column>
            <Column xs='12' lg='6'>
              <SolutionCard>
                <Icons.Index2 />
                <h3>云游戏Iaas解决方案</h3>
                <p>
                  为云游戏平台或技术提供商提供稳定可靠、高性价比的基础设施服务，包括服务器、边缘计算节点、网络、系统，为云游戏平台赋能，摆脱沉重的IT计算设施的投入。
                </p>
              </SolutionCard>
            </Column>
          </Row>
        </Wrapper>
      </Section>
      <DarkSection>
        <Background src={BG} alt='' />
        <Wrapper>
          <Title>我们的优势</Title>
          <Row style={{ marginBottom: 90 }}>
            <Column xs='6' lg='3'>
              <OddsCard>
                <OddsIconWrap>
                  <Icons.Index3 />
                </OddsIconWrap>
                <h3>专业的核心技术</h3>
                <p>
                  在并行计算、大规模集群调度、高性能I/O系统方向经验丰富，同时拥有自研的音视频串流技术，彻底解决了高时延、丢包率高等问题，助力开发者快速完成游戏上云。
                </p>
              </OddsCard>
            </Column>
            <Column xs='6' lg='3'>
              <OddsCard>
                <OddsIconWrap>
                  <Icons.Index4 />
                </OddsIconWrap>
                <h3>极致性价比的GPU资源</h3>
                <p>
                  提供极具性价比的GPU资源（含vGPU），以及配套存储、网络等IaaS产品，在为客户提供卓越性能的同时，也降低了客户游戏业务运营的成本。
                </p>
              </OddsCard>
            </Column>
            <Column xs='6' lg='3'>
              <OddsCard>
                <OddsIconWrap>
                  <Icons.Index5 />
                </OddsIconWrap>
                <h3>可定制化的平台服务</h3>
                <p>
                  可根据需求定制专属的特色功能与服务，除通用管理功能外，全方位满足各游戏内容厂商以及云游戏平台的专项需求，以保障游戏顺利上云。{' '}
                </p>
              </OddsCard>
            </Column>
            <Column xs='6' lg='3'>
              <OddsCard>
                <OddsIconWrap>
                  <Icons.Index6 />
                </OddsIconWrap>
                <h3>高效的资源交付能力</h3>
                <p>
                  提供海量的GPU边缘计算资源，满足云游戏不同场景下的节点性能需求，就近部署，就近分配，支持包机和按需模式弹性调配。{' '}
                </p>
              </OddsCard>
            </Column>
          </Row>
        </Wrapper>
      </DarkSection>
      <DarkSection>
        <Wrapper>
          <Title>合作伙伴</Title>
          <Row style={{ marginBottom: 90 }}>
            <Column xs='6' lg='3'>
              <PartnerCard>
                <img src={NvidiaLogo} alt='' />
              </PartnerCard>
            </Column>
            <Column xs='6' lg='3'>
              <PartnerCard>
                <img src={AMDLogo} alt='' />
              </PartnerCard>
            </Column>
            <Column xs='6' lg='3'>
              <PartnerCard>
                <img src={ARMLogo} alt='' />
              </PartnerCard>
            </Column>
            <Column xs='6' lg='3'>
              <PartnerCard>
                <img src={IntelLogo} alt='' />
              </PartnerCard>
            </Column>
          </Row>
        </Wrapper>
      </DarkSection>
    </Layout>
  )
}

export default Index
export const query = graphql`
  query {
    banner: file(relativePath: { regex: "/index/banner.png/" }) {
      ...fluidImage
    }
  }
`
